export const actionTypes = {
  GET_MONTH_LOCKS: "GET_MONTH_LOCKS",
  SET_MONTH_LOCKS: "SET_MONTH_LOCKS",

  GET_YEAR_OPTIONS: "GET_YEAR_OPTIONS",
  SET_YEAR_OPTIONS: "SET_YEAR_OPTIONS",

  LOCK_MONTH: "LOCK_MONTH",
  UPDATE_MONTHLOCK: "UPDATE_MONTHLOCK"
};

export const actions = {
  getMonthLocks: (payload) => ({
    type: actionTypes.GET_MONTH_LOCKS,
    payload: payload,
  }),

  setMonthLocks: (payload) => ({
    type: actionTypes.SET_MONTH_LOCKS,
    payload: payload,
  }),

  lockMonth: (payload) => ({
    type: actionTypes.LOCK_MONTH,
    payload: payload,
  }),

  updateMonthLock: (payload) => ({
    type: actionTypes.UPDATE_MONTHLOCK,
    payload: payload,
  }),

  getYearOptions: (payload) => ({
    type: actionTypes.GET_YEAR_OPTIONS,
    payload: payload,
  }),

  setYearOptions: (payload) => ({
    type: actionTypes.SET_YEAR_OPTIONS,
    payload: payload,
  }),
};
